// @ts-nocheck
/*
 * Copyright (C) 2023 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

export default function loadLocale(locale: string) {
  switch (locale) {
    case 'moment/locale/af':
      return import('moment/locale/af')

    case 'moment/locale/ar-dz':
      return import('moment/locale/ar-dz')

    case 'moment/locale/ar-kw':
      return import('moment/locale/ar-kw')

    case 'moment/locale/ar-ly':
      return import('moment/locale/ar-ly')

    case 'moment/locale/ar-ma':
      return import('moment/locale/ar-ma')

    case 'moment/locale/ar-sa':
      return import('moment/locale/ar-sa')

    case 'moment/locale/ar-tn':
      return import('moment/locale/ar-tn')

    case 'moment/locale/ar':
      return import('moment/locale/ar')

    case 'moment/locale/az':
      return import('moment/locale/az')

    case 'moment/locale/be':
      return import('moment/locale/be')

    case 'moment/locale/bg':
      return import('moment/locale/bg')

    case 'moment/locale/bm':
      return import('moment/locale/bm')

    case 'moment/locale/bn-bd':
      return import('moment/locale/bn-bd')

    case 'moment/locale/bn':
      return import('moment/locale/bn')

    case 'moment/locale/bo':
      return import('moment/locale/bo')

    case 'moment/locale/br':
      return import('moment/locale/br')

    case 'moment/locale/bs':
      return import('moment/locale/bs')

    case 'moment/locale/cs':
      return import('moment/locale/cs')

    case 'moment/locale/cv':
      return import('moment/locale/cv')

    case 'moment/locale/cy':
      return import('moment/locale/cy')

    case 'moment/locale/da':
      return import('moment/locale/da')

    case 'moment/locale/de-at':
      return import('moment/locale/de-at')

    case 'moment/locale/de-ch':
      return import('moment/locale/de-ch')

    case 'moment/locale/dv':
      return import('moment/locale/dv')

    case 'moment/locale/el':
      return import('moment/locale/el')

    case 'moment/locale/en-au':
      return import('moment/locale/en-au')

    case 'moment/locale/en-ca':
      return import('moment/locale/en-ca')

    case 'moment/locale/en-gb':
      return import('moment/locale/en-gb')

    case 'moment/locale/en-ie':
      return import('moment/locale/en-ie')

    case 'moment/locale/en-il':
      return import('moment/locale/en-il')

    case 'moment/locale/en-in':
      return import('moment/locale/en-in')

    case 'moment/locale/en-nz':
      return import('moment/locale/en-nz')

    case 'moment/locale/en-sg':
      return import('moment/locale/en-sg')

    case 'moment/locale/eo':
      return import('moment/locale/eo')

    case 'moment/locale/es-do':
      return import('moment/locale/es-do')

    case 'moment/locale/es-mx':
      return import('moment/locale/es-mx')

    case 'moment/locale/es-us':
      return import('moment/locale/es-us')

    case 'moment/locale/es':
      return import('moment/locale/es')

    case 'moment/locale/et':
      return import('moment/locale/et')

    case 'moment/locale/eu':
      return import('moment/locale/eu')

    case 'moment/locale/fi':
      return import('moment/locale/fi')

    case 'moment/locale/fil':
      return import('moment/locale/fil')

    case 'moment/locale/fo':
      return import('moment/locale/fo')

    case 'moment/locale/fr-ch':
      return import('moment/locale/fr-ch')

    case 'moment/locale/fy':
      return import('moment/locale/fy')

    case 'moment/locale/ga':
      return import('moment/locale/ga')

    case 'moment/locale/gd':
      return import('moment/locale/gd')

    case 'moment/locale/gl':
      return import('moment/locale/gl')

    case 'moment/locale/gom-deva':
      return import('moment/locale/gom-deva')

    case 'moment/locale/gom-latn':
      return import('moment/locale/gom-latn')

    case 'moment/locale/gu':
      return import('moment/locale/gu')

    case 'moment/locale/hi':
      return import('moment/locale/hi')

    case 'moment/locale/hr':
      return import('moment/locale/hr')

    case 'moment/locale/hu':
      return import('moment/locale/hu')

    case 'moment/locale/id':
      return import('moment/locale/id')

    case 'moment/locale/is':
      return import('moment/locale/is')

    case 'moment/locale/it-ch':
      return import('moment/locale/it-ch')

    case 'moment/locale/it':
      return import('moment/locale/it')

    case 'moment/locale/jv':
      return import('moment/locale/jv')

    case 'moment/locale/ka':
      return import('moment/locale/ka')

    case 'moment/locale/kk':
      return import('moment/locale/kk')

    case 'moment/locale/km':
      return import('moment/locale/km')

    case 'moment/locale/kn':
      return import('moment/locale/kn')

    case 'moment/locale/ko':
      return import('moment/locale/ko')

    case 'moment/locale/ku':
      return import('moment/locale/ku')

    case 'moment/locale/ky':
      return import('moment/locale/ky')

    case 'moment/locale/lb':
      return import('moment/locale/lb')

    case 'moment/locale/lo':
      return import('moment/locale/lo')

    case 'moment/locale/lt':
      return import('moment/locale/lt')

    case 'moment/locale/lv':
      return import('moment/locale/lv')

    case 'moment/locale/me':
      return import('moment/locale/me')

    case 'moment/locale/mi':
      return import('moment/locale/mi')

    case 'moment/locale/mk':
      return import('moment/locale/mk')

    case 'moment/locale/ml':
      return import('moment/locale/ml')

    case 'moment/locale/mn':
      return import('moment/locale/mn')

    case 'moment/locale/mr':
      return import('moment/locale/mr')

    case 'moment/locale/ms-my':
      return import('moment/locale/ms-my')

    case 'moment/locale/ms':
      return import('moment/locale/ms')

    case 'moment/locale/mt':
      return import('moment/locale/mt')

    case 'moment/locale/my':
      return import('moment/locale/my')

    case 'moment/locale/nb':
      return import('moment/locale/nb')

    case 'moment/locale/ne':
      return import('moment/locale/ne')

    case 'moment/locale/nl-be':
      return import('moment/locale/nl-be')

    case 'moment/locale/nl':
      return import('moment/locale/nl')

    case 'moment/locale/nn':
      return import('moment/locale/nn')

    case 'moment/locale/oc-lnc':
      return import('moment/locale/oc-lnc')

    case 'moment/locale/pa-in':
      return import('moment/locale/pa-in')

    case 'moment/locale/pt-br':
      return import('moment/locale/pt-br')

    case 'moment/locale/pt':
      return import('moment/locale/pt')

    case 'moment/locale/ro':
      return import('moment/locale/ro')

    case 'moment/locale/ru':
      return import('moment/locale/ru')

    case 'moment/locale/sd':
      return import('moment/locale/sd')

    case 'moment/locale/se':
      return import('moment/locale/se')

    case 'moment/locale/si':
      return import('moment/locale/si')

    case 'moment/locale/sk':
      return import('moment/locale/sk')

    case 'moment/locale/sq':
      return import('moment/locale/sq')

    case 'moment/locale/sr-cyrl':
      return import('moment/locale/sr-cyrl')

    case 'moment/locale/sr':
      return import('moment/locale/sr')

    case 'moment/locale/ss':
      return import('moment/locale/ss')

    case 'moment/locale/sv':
      return import('moment/locale/sv')

    case 'moment/locale/sw':
      return import('moment/locale/sw')

    case 'moment/locale/ta':
      return import('moment/locale/ta')

    case 'moment/locale/te':
      return import('moment/locale/te')

    case 'moment/locale/tet':
      return import('moment/locale/tet')

    case 'moment/locale/tg':
      return import('moment/locale/tg')

    case 'moment/locale/th':
      return import('moment/locale/th')

    case 'moment/locale/tk':
      return import('moment/locale/tk')

    case 'moment/locale/tl-ph':
      return import('moment/locale/tl-ph')

    case 'moment/locale/tlh':
      return import('moment/locale/tlh')

    case 'moment/locale/tr':
      return import('moment/locale/tr')

    case 'moment/locale/tzl':
      return import('moment/locale/tzl')

    case 'moment/locale/tzm-latn':
      return import('moment/locale/tzm-latn')

    case 'moment/locale/tzm':
      return import('moment/locale/tzm')

    case 'moment/locale/ug-cn':
      return import('moment/locale/ug-cn')

    case 'moment/locale/uk':
      return import('moment/locale/uk')

    case 'moment/locale/ur':
      return import('moment/locale/ur')

    case 'moment/locale/uz-latn':
      return import('moment/locale/uz-latn')

    case 'moment/locale/uz':
      return import('moment/locale/uz')

    case 'moment/locale/vi':
      return import('moment/locale/vi')

    case 'moment/locale/x-pseudo':
      return import('moment/locale/x-pseudo')

    case 'moment/locale/yo':
      return import('moment/locale/yo')

    case 'moment/locale/zh-hk':
      return import('moment/locale/zh-hk')

    case 'moment/locale/zh-mo':
      return import('moment/locale/zh-mo')

    case 'moment/locale/zh-tw':
      return import('moment/locale/zh-tw')

    case 'moment/locale/ca':
      return import('./ext/custom_moment_locales/ca')

    case 'moment/locale/de':
      return import('./ext/custom_moment_locales/de')

    case 'moment/locale/fa':
      return import('./ext/custom_moment_locales/fa')

    case 'moment/locale/fr':
      return import('./ext/custom_moment_locales/fr')

    case 'moment/locale/fr-ca':
      return import('./ext/custom_moment_locales/fr_ca')

    case 'moment/locale/he':
      return import('./ext/custom_moment_locales/he')

    case 'moment/locale/ht-ht':
      return import('./ext/custom_moment_locales/ht_ht')

    case 'moment/locale/hy-am':
      return import('./ext/custom_moment_locales/hy_am')

    case 'moment/locale/mi-nz':
      return import('./ext/custom_moment_locales/mi_nz')

    case 'moment/locale/pl':
      return import('./ext/custom_moment_locales/pl')

    case 'moment/locale/sl':
      return import('./ext/custom_moment_locales/sl')

    case 'moment/locale/ja':
      return import('./ext/custom_moment_locales/ja')

    case 'moment/locale/zh-cn':
      return import('./ext/custom_moment_locales/zh_cn')

    default:
      // eslint-disable-next-line no-console
      console.warn("couldn't load moment/locale/", locale)
  }
}
